export default __webpack_public_path__ + "static/media/pic6.53fb1438.jpg";